<template>
  <div class="flex flex-col items-center justify-center py-14 px-4 text-center">
    <div v-if="icon" class="mb-4 rounded-full bg-muted p-4">
      <component :is="icon" class="h-8 w-8 text-muted-foreground" />
    </div>
    <h3 class="text-sm font-semibold text-foreground">{{ title }}</h3>
    <p v-if="description" class="mt-1 text-sm text-muted-foreground max-w-xs">{{ description }}</p>
    <div v-if="$slots.action" class="mt-4">
      <slot name="action" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  icon:        { type: [Object, Function], default: null },
  title:       { type: String, default: 'Nothing here yet' },
  description: { type: String, default: '' },
})
</script>
